import { useUser } from 'models';
import React from 'react'

export default function({user,style}){
  const color = user.color.getHex();
  const colorBorder = user.color.getColorEquivalent(.1).getHex();
  return (
    <div className="user-circle-by-name" style={{backgroundColor: color, borderColor: colorBorder,...style}}>
      {user.image?
      <img src={user.image} alt={user.name} onLoad={(e)=>{
        let target = e.target;
        let size = {
          height:target.clientHeight,
          width:target.clientWidth,
        };
        if(size.height < size.width){
          target.style.height = "100%";
          target.style.width = "auto";
        }
      }}/>
      :
      <label style={{color: user.color.getColorToBackground()}}>{user.name.toUpperCase()[0]}</label>
      }
    </div>
  );
}